import React from 'react';
import { Typography } from '../../components';
import "./styles.css";

import logocfconnect from '../../assets/images/inloggen/logocfconnect.png';
import logocfacademy from '../../assets/images/inloggen/logocfacademy.png';
import logocfcommunity from '../../assets/images/inloggen/logocfcommunity.png';

import { Container, Introduction, LoginCardWrapper } from './styled';

export default function Inloggen(props) {

const LoginCard = ({ title, subtitle, img, alt, href }) => (
    <LoginCardWrapper onClick={() => window.open(href, '_blank')}>
      <Typography type="h2" style={{ color: '#114d55' }}>{title}</Typography>
      <Typography type="body">{subtitle}</Typography>
      <img src={img} alt={alt} />
    </LoginCardWrapper>
  );

    return (
        <Container>
            <Introduction>
                <Typography type='h1' style={{ color: '#114d55', margin: '0 0 3vw 0' }}>
                    Jouw online omgeving van Centering Feeding
                </Typography>
                <Typography type='caps' style={{ color: '#B2522D' }}>
                    Klik op de online omgeving waar jij wilt inloggen.
                </Typography>
            </Introduction>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '3vw',
                    flexWrap: 'wrap'
                }}
            >
                {/* CF Connect */}
                <LoginCard
                    title="Centering Feeding Connect"
                    subtitle="Voor ouders"
                    img={logocfconnect}
                    alt="Centering Feeding Connect"
                    href="https://kenniscentrumvoorouders.centeringfeeding.nl"
                />

                {/* CF Academy */}
                <LoginCard
                    title="Centering Feeding Academy"
                    subtitle="Voor zorgprofessionals"
                    img={logocfacademy}
                    alt="Centering Feeding Academy"
                    href="https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl"
                />

                {/* CF Community */}
                <LoginCard
                    title="Centering Feeding Community"
                    subtitle="Voor begeleiders"
                    img={logocfcommunity}
                    alt="Centering Feeding Community"
                    href="https://kenniscentrumvoorlactatiekundigen.centeringfeeding.nl"
                />
            </div>
        </Container>
    );
}